import _ from 'lodash';
import { injectable, inject, optional } from '@patsnap/tahiti-core/shared/inversify';
import type { Router } from 'vue-router';
import { RouterService } from '@eureka/shared/core-services/src/vue-router-service';
import { BiTrackApi } from '../../apis/bi-track-api';
import type { BiTrackEventType } from '../../types';
import type { BiTrackRepository } from '../../services/bi-track-repository';

@injectable()
export class BiTrackRepositoryImpl implements BiTrackRepository {
    constructor(
        @inject(BiTrackApi) private _biTrackApi: BiTrackApi,
        @inject(RouterService) @optional() private _router?: Router
    ) { }

    private _stringify(data: Record<string, unknown>) {
        return JSON.stringify(data);
    }

    biTrack(eventType: string, data: BiTrackEventType) {
        const { sourceType, otherParam, eventDetailStr } = data;
        const params = this._router?.currentRoute.value.params;
        const sessionId = params?.triz_mind_id || params?.job_id;
        let detailStr = eventDetailStr;
        if (!_.isString(eventDetailStr) && eventDetailStr) {
            eventDetailStr.page_url = window.location.href
            detailStr = eventDetailStr ? this._stringify(eventDetailStr) : undefined;
        }

        return this._biTrackApi.biTrack({
            event_type: eventType,
            source_type: sourceType,
            ...(typeof sessionId === 'string' && sessionId ? { session_id: sessionId } : {}),
            other_param: otherParam,
            event_detail_str: detailStr as string,
            module_type: 'EUREKA',
        });
    }
}
